import { render } from "./YoutubePlayerSmall.vue?vue&type=template&id=0d7b804f&scoped=true"
import script from "./YoutubePlayerSmall.vue?vue&type=script&lang=js"
export * from "./YoutubePlayerSmall.vue?vue&type=script&lang=js"

import "./YoutubePlayerSmall.vue?vue&type=style&index=0&id=0d7b804f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7b804f"]])

export default __exports__